import { styled, Paragraph } from '@mybonus/ui';

export const Description = styled(Paragraph)`
	text-align: center;
`;
